import dayjs, { Dayjs } from 'dayjs';
import { object, string } from 'yup';

import { UserRewardType } from 'v2/constants';
import { Nullable } from 'v2/types';

export type IEntryRewardForm = {
  title: string;
  description: string;
  imageId: string;
  activationDate: Dayjs;
  expirationDate: Nullable<Dayjs>;
  type: UserRewardType;
  value: string;
};

export const initialValues: IEntryRewardForm = {
  title: '',
  description: '',
  imageId: '',
  activationDate: dayjs(),
  expirationDate: null,
  type: UserRewardType.CONTEST_TICKET,
  value: '',
};

export const validationSchema = object().shape({
  imageId: string().trim().required(),
});
